import { AssistantsList } from 'presentation/app/modules/Professionals/Assistants/pages/assistants-list';
import React from 'react';

export const MakeAssistantsList: React.FC = () => {
  return <AssistantsList />;
};
